import { rem } from 'polished';
import styled from 'styled-components';

export const Section = styled('section')`
  padding: ${rem(24)};

  button {
    padding: 0;
    font-size: ${rem(14)};
    font-weight: 500;
    border: none;
    cursor: pointer;
  }

  a,
  button {
    svg {
      position: relative;
      top: ${rem(1)};
      margin-right: ${rem(8)};
    }
  }

  a svg {
    top: ${rem(2)};
  }

  .practitioners {
    margin-bottom: ${rem(48)};
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    h3 {
      margin-bottom: ${rem(22)};
    }

    .view-all {
      margin: 0;
      font-size: ${rem(14)};

      a {
        color: currentcolor;
        font-weight: 500;
        text-decoration: underline;
      }
    }

    .loader {
      width: 100%;
    }

    > ul {
      margin: 0;
      padding: 0;
    }
  }

  aside {
    margin-bottom: ${rem(64)};
  }

  .link-list {
    margin-bottom: ${rem(100)};
  }

  main {
    .appointment-cards > li {
      width: 100%;
    }
  }

  @media screen and (min-width: 576px) {
    .link-list {
      margin-bottom: auto;
    }
  }

  @media screen and (min-width: 901px) and (max-width: 980px),
    screen and (min-width: 1201px) {
    main {
      display: flex;
      flex-flow: row;

      .link-list {
        max-width: ${rem(294)};
        min-width: ${rem(165)};
        margin-left: ${rem(32)};
        margin-top: ${rem(40)};
        flex: 1 1 auto;
      }
    }
  }

  @media screen and (min-width: 951px) {
    .hero-banner .cta button {
      width: auto;
    }
  }

  @media screen and (min-width: 1101px) {
    padding: ${rem(48)} ${rem(40)};
  }
`;
